import { QueryStatus } from 'react-query';
import { ExportModalContentsProps } from 'components/ExportModalContents';
import { ExportFormat } from 'types';

export function getExportModalDefaultProps(
  status: QueryStatus,
  exportFormat?: ExportFormat,
): Partial<ExportModalContentsProps> | undefined {
  switch (exportFormat) {
    case 'video': {
      if (status !== 'loading') {
        return undefined;
      }

      return {
        subtitle:
          'You don’t need to wait here, we will send you an email when the video is ready to be downloaded.',
      };
    }

    default:
      return undefined;
  }
}
